<template>
  <div class="font_style_group">
    <!-- <el-tooltip class="item" effect="dark" content="颜色" placement="top"> -->
      <span
        :class="{'style_item style_item_through':true,'style_item_active':decoration==='line-through' || $store.state.color.isShow,'bg_color':scShow===true}"
            @click="on_click_decoration('line-through')">
         <svg class="icon img-icon" aria-hidden="true">
                <use xlink:href="#icon-xiahuaixian16"></use>
            </svg>
      </span>
    <!-- </el-tooltip> -->
    <el-tooltip class="item" effect="dark" content="加粗" placement="top">
        <span
        :class="{'style_item style_item_weight':true,'style_item_active':weight==='bold'}"
              @click="on_click_weight">
            <svg class="icon img-icon" aria-hidden="true">
                <use xlink:href="#icon-jiacu16"></use>
            </svg>
        </span>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="斜体" placement="top">
        <span
        :class="{'style_item style_item_style':true,'style_item_active':style==='italic'}"
              @click="on_click_style">
            <svg class="icon img-icon" aria-hidden="true">
                <use xlink:href="#icon-xieben16"></use>
            </svg>
            <!-- <img class="img-icon" src="/images/icon/icon-font-italic.svg" alt=""> -->
        </span>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="下划线" placement="top">
      <span
      :class="{'style_item style_item_underline':true,'style_item_active':decoration==='underline', 'bg_color':xhxShow===true}"
            @click="on_click_decoration('underline')">
         <svg class="icon img-icon" aria-hidden="true">
                <use xlink:href="#icon-xiahuaixian162"></use>
            </svg>
      </span>
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'MyFontStyle',
  data() {
    return {
      weight: 'normal',
      style: 'normal',
      decoration: 'none',
      hsShow: false,
      xhxShow: false,
      scShow: false
    }
  },
  props: {
    'font-weight': {
      type: String,
      default: 'normal'
    },
    'font-style': {
      type: String,
      default: 'normal'
    },
    'text-decoration': {
      type: String,
      default: 'none'
    }
  },
  methods: {
    on_click_weight() {
      this.weight = this.weight === 'normal' ? 'bold' : 'normal'
      this.$emit('changeFontWeight', this.weight)
    },
    on_click_style() {
      this.style = this.style === 'normal' ? 'italic' : 'normal'
      this.$emit('changeFontStyle', this.style)
    },
    on_click_decoration(type) {
      if (type === 'underline') {
        this.xhxShow = !this.xhxShow
      } else {
        this.scShow = !this.scShow
      }
      // this.decoration = this.decoration === type ? 'none' : type
      this.$emit('changeTextDecoration', type)
    },
    on_click_writing_mode() {
      this.hsShow = !this.hsShow
      this.$emit('changeWritingMode', '')
    }
  }
}
</script>

<style lang="scss" scoped>
.font_style_group {
  user-select: none;
  margin-top: 20px;
  border: 1px solid #E8E8F0;
  border-radius: 4px;
}

.style_item {
  display: inline-block;
  flex: 1;
  height: 32px;
  line-height: 32px;
  text-align: center;
  background: #FFFFFF;
  // border: 1px solid #D5D5D5;
  // border-right: 0;
  // border-left: 0;
  cursor: pointer;
  &:first-child{
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }
  &:last-child{
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }
  &:not(:last-child){
    border-right: #E5E6EB solid 1px;
  }
  .img-icon {
    width: 16px;
    height: 16px;
    vertical-align: middle;
  }
}

// .style_item_direction {
//   // .img-icon {
//   //   // width: 15px;
//   //   // height: 14px;
//   // }
// }

// .style_item:last-child {
//   border-right: 1px solid #D5D5D5;
// }
// .style_item:nth-child(1) {
//   border-left: 1px solid #D5D5D5;
// }

.style_item_weight.style_item_active {
  font-weight: bold;
}

.style_item_style.style_item_active {
  font-style: italic;
}

.style_item_underline.style_item_active {
  text-decoration: underline;
}

.style_item_through.style_item_active {
  text-decoration: line-through;
}
.style_item_active,
.bg_color {
  background-color: #F0F0F0;
}

</style>
